import {Version} from '@angular/core';

/** Current version of Angular MDC. */
export const VERSION = new Version('5.1.1');
